export default class OverleafApi {
  private isInitialized;
  private overleafApi;
  private readonly config;

  constructor() {
    this.config = {
      sessionId: window.Overleaf?.sessionId,
    };
    this.isInitialized = false;
  }

  async getInstance() {
    if (window.Overleaf) {
      if (!this.isInitialized) {
        await this.authenticate();
        this.isInitialized = true;
        this.overleafApi = window.Overleaf;
      }
      return this.overleafApi;
    }
  }

  async authenticate() {
    return await window.Overleaf!.init(this.config);
  }
}
